import { RssLiveInformationProvider } from "client_legacy/Workspace/LiveInformation/Rss/provider";
import { BookmarksProvider, DocumentsLiveInformationProvider } from "client_legacy/Workspace/LiveInformation/Documents/provider";
import { EmailLiveInformationProvider } from "client_legacy/Workspace/LiveInformation/Email/provider";
import { CalendarLiveInformationProvider } from "client_legacy/Workspace/LiveInformation/Calendar/provider";
import { ToDoLiveInformationProvider } from "./Tiles/ToDo/provider";
import { TopDeskLiveInformationProvider } from "client_legacy/Workspace/LiveInformation/TopDesk/provider";
import { ConnectWiseLiveInformationProvider } from "client_legacy/Workspace/LiveInformation/ConnectWise/provider";
import { HowToLiveInformationProvider } from "./Tiles/howToTile/provider";
import { AnnouncementsLiveInformationProvider } from "client_legacy/Workspace/LiveInformation/Hub/announcementProvider";
import { EventLiveInformationProvider } from "client_legacy/Workspace/LiveInformation/Hub/eventProvider";
import { KnowledgeItemLiveInformationProvider } from "client_legacy/Workspace/LiveInformation/Hub/knowledgeItemProvider";
import { TeamsProvider } from "./Tiles/Teams/provider";
import { SharePointProvider } from "./Tiles/SharePoint/provider";
import { AutotaskLiveInformationProvider } from "client_legacy/Workspace/LiveInformation/Autotask/provider";
import { NedapOnsLiveInformationProvider } from "./Tiles/NedapOns/provider";
import { AfasLiveInformationProvider } from "./Tiles/Afas/provider";
import { ZaaksysteemLiveInformationProvider } from "client_legacy/Workspace/LiveInformation/Zaaksysteem/provider";
import { ZenyaDocLiveInformationProvider } from "./Tiles/ZenyaDoc/provider";
import { ZermeloLiveInformationProvider } from "./Tiles/Zermelo/provider";
import { MagisterLiveInformationProvider } from "./Tiles/Magister/provider";
import { AddressBookSettings, TileFactoryConfiguration } from "client/Api/Workspace/common";
import { useState } from "react";
import { CommunityLiveInformationProvider } from "client_legacy/Workspace/LiveInformation/Hub/communityProvider";

export type TileContentDependencies = {
	rssLiveInformationProvider: RssLiveInformationProvider;
	documentsLiveInformationProvider: DocumentsLiveInformationProvider;
	bookmarksProvider: BookmarksProvider;
	emailLiveInformationProvider: EmailLiveInformationProvider;
	calendarLiveInformationProvider: CalendarLiveInformationProvider;
	toDoLiveInformationProvider: ToDoLiveInformationProvider;
	topDeskLiveInformationProvider: TopDeskLiveInformationProvider;
	connectWiseLiveInformationProvider: ConnectWiseLiveInformationProvider;
	howToLiveInformationProvider: HowToLiveInformationProvider;
	announcementsProvider: AnnouncementsLiveInformationProvider;
	eventsProvider: EventLiveInformationProvider;
	knowledgeItemProvider: KnowledgeItemLiveInformationProvider;
	communityProvider: CommunityLiveInformationProvider;
	teamsProvider: TeamsProvider;
	sharePointProvider: SharePointProvider;
	autotaskLiveInformationProvider: AutotaskLiveInformationProvider;
	nedapOnsLiveInformationProvider: NedapOnsLiveInformationProvider;
	afasLiveInformationProvider: AfasLiveInformationProvider;
	zaaksysteemLiveInformationProvider: ZaaksysteemLiveInformationProvider;
	zenyaDocLiveInformationProvider: ZenyaDocLiveInformationProvider;
	zermeloLiveInformationProvider: ZermeloLiveInformationProvider;
	magisterLiveInformationProvider: MagisterLiveInformationProvider;
	addressBookSettings: AddressBookSettings;
};

export function useTileContentDependencies(
	configuration: TileFactoryConfiguration
): TileContentDependencies {
	const [result] = useState<TileContentDependencies>(
		() => createTileContentDependencies(configuration)
	);

	return result;
}

function createTileContentDependencies(
	configuration: TileFactoryConfiguration
): TileContentDependencies {
	return {
		rssLiveInformationProvider: new RssLiveInformationProvider({
			intervalInSeconds: configuration.rssTileUpdateInterval
		}),

		documentsLiveInformationProvider: new DocumentsLiveInformationProvider({
			intervalInSeconds: configuration.liveDocumentsUpdateInterval
		}),

		bookmarksProvider: new BookmarksProvider(),

		emailLiveInformationProvider: new EmailLiveInformationProvider({
			intervalInSeconds: configuration.liveEmailUpdateInterval
		}),

		calendarLiveInformationProvider: new CalendarLiveInformationProvider({
			intervalInSeconds: configuration.liveCalendarUpdateInterval
		}),

		toDoLiveInformationProvider: new ToDoLiveInformationProvider({
			intervalInSeconds: configuration.liveToDoUpdateInterval
		}),

		topDeskLiveInformationProvider: new TopDeskLiveInformationProvider({
			intervalInSeconds: configuration.topDesk.liveUpdateInterval,
		}),

		connectWiseLiveInformationProvider: new ConnectWiseLiveInformationProvider({
			intervalInSeconds: configuration.connectWise.liveUpdateInterval,
			isConnectWiseConfigured: configuration.connectWise.isConfigured,
			customerPortalUrl: configuration.connectWise.customerPortalUrl
		}),

		howToLiveInformationProvider: new HowToLiveInformationProvider({
			intervalInSeconds: configuration.liveHowToUpdateInterval
		}),

		announcementsProvider: new AnnouncementsLiveInformationProvider({
			intervalInSeconds: configuration.liveHubUpdateInterval
		}),

		eventsProvider: new EventLiveInformationProvider({
			intervalInSeconds: configuration.liveHubUpdateInterval
		}),

		knowledgeItemProvider: new KnowledgeItemLiveInformationProvider({
			intervalInSeconds: configuration.liveHubUpdateInterval
		}),

		communityProvider: new CommunityLiveInformationProvider(),

		teamsProvider: new TeamsProvider(configuration.isTeamsAvailable),
		sharePointProvider: new SharePointProvider(),
		autotaskLiveInformationProvider: new AutotaskLiveInformationProvider({
			intervalInSeconds: configuration.autotask.liveUpdateInterval
		}),
		nedapOnsLiveInformationProvider: new NedapOnsLiveInformationProvider({
			intervalInSeconds: configuration.nedapOns.liveUpdateInterval
		}),
		afasLiveInformationProvider: new AfasLiveInformationProvider({
			intervalInSeconds: configuration.afas.liveUpdateInterval
		}),
		zaaksysteemLiveInformationProvider: new ZaaksysteemLiveInformationProvider({
			intervalInSeconds: configuration.zaaksysteem.liveUpdateInterval
		}),

		zenyaDocLiveInformationProvider: new ZenyaDocLiveInformationProvider({
			intervalInSeconds: configuration.zenyaDoc.liveUpdateInterval
		}),

		zermeloLiveInformationProvider: new ZermeloLiveInformationProvider({
			intervalInSeconds: configuration.zermelo.liveUpdateInterval
		}),

		magisterLiveInformationProvider: new MagisterLiveInformationProvider({
			intervalInSeconds: configuration.magister.liveUpdateInterval
		}),

		addressBookSettings: configuration.addressBook
	};
}
